(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridal-consultation"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript;
  function initReveal() {
    var els = document.querySelectorAll('.bridal .reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Open the Calendly popup when a "Book Your Consultation" button is clicked.
  // Falls back to opening the booking page (the href) if the widget isn't ready.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bridal .bridal__btn');
    if (!btn) return;
    if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
      e.preventDefault();
      window.Calendly.initPopupWidget({ url: btn.getAttribute('href') });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvyy-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var grid = document.querySelector('[data-sb-grid]');
      var sentinel = document.querySelector('[data-sb-sentinel]');
      if (!grid || !sentinel || !('IntersectionObserver' in window)) return;

      var loading = false;

      function stop() {
        observer.disconnect();
        if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
      }

      function loadNext() {
        var nextUrl = sentinel.getAttribute('data-sb-next');
        if (!nextUrl) { stop(); return; }
        loading = true;
        fetch(nextUrl)
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (html) {
            if (!html) { loading = false; return; }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('[data-sb-grid] .savvyy-blog__card');
            for (var i = 0; i < cards.length; i++) {
              grid.appendChild(document.importNode(cards[i], true));
            }
            var nextSentinel = doc.querySelector('[data-sb-sentinel]');
            if (nextSentinel && nextSentinel.getAttribute('data-sb-next')) {
              sentinel.setAttribute('data-sb-next', nextSentinel.getAttribute('data-sb-next'));
              loading = false;
            } else {
              stop();
            }
          })
          .catch(function () { loading = false; });
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !loading) loadNext();
        });
      }, { rootMargin: '400px 0px' });

      observer.observe(sentinel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  (function () {
    function initFilters() {
      var bars = document.querySelectorAll('.savvyy-blog__filters');
      for (var b = 0; b < bars.length; b++) {
        (function (nav) {
          var track = nav.querySelector('[data-sb-filter-track]');
          var left = nav.querySelector('.savvyy-blog__filter-arrow--left');
          var right = nav.querySelector('.savvyy-blog__filter-arrow--right');
          if (!track) return;

          function update() {
            var max = track.scrollWidth - track.clientWidth - 1;
            if (left) left.classList.toggle('is-hidden', track.scrollLeft <= 0);
            if (right) right.classList.toggle('is-hidden', track.scrollLeft >= max);
          }

          if (left) left.addEventListener('click', function () {
            track.scrollBy({ left: -240, behavior: 'smooth' });
          });
          if (right) right.addEventListener('click', function () {
            track.scrollBy({ left: 240, behavior: 'smooth' });
          });
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);

          var active = track.querySelector('.savvyy-blog__filter.is-active');
          if (active) active.scrollIntoView({ inline: 'center', block: 'nearest' });

          update();
        })(bars[b]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilters);
    } else {
      initFilters();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
